module.exports = __webpack_public_path__ + "static/TGIC Report cover mockup-737da952555ed06e5348351a49e6f6c8.png";